import { ODataResponse } from '../../../models/odata';

export const ODATA_COUNT_KEY = '@odata.count';

export function mapODataResponse<T>(data: any): ODataResponse<T> {
    const items: any[] = data.value;

    const odataResponse: ODataResponse<T> = {
        value: [],
        count: 0,
    };

    if (items) {
        odataResponse.value = items;
        odataResponse.count = data[ODATA_COUNT_KEY];
    }

    // eslint-disable-next-line no-prototype-builtins
    if (!items && !data.hasOwnProperty(ODATA_COUNT_KEY)) {
        return data;
    }

    return odataResponse;
}
